import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M23 3H1v18h22V3zm-11 8H3V9h9v2zm0-4H3V5h9v2z"
}), 'FeaturedPlayListSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FeaturedPlayListSharp.js
// module id = 3532
// module chunks = 2